import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import SiteGen2 from './SiteGen2'

function GeneratorPage2() {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen gradient-bg relative overflow-hidden">
      <div className="absolute inset-0 bg-cyber-grid opacity-30 pointer-events-none"></div>
      <div className="relative z-20 p-4">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors duration-200 group"
        >
          <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform duration-200" />
          <span>Back to Home</span>
        </button>
      </div>
      <div className="px-4 pb-8">
        <SiteGen2 />
      </div>
    </div>
  )
}

export default GeneratorPage2 